export default "__VITE_ASSET__CPI1BLvL__"